// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-default.section-default--testimonials{max-width:1440px;overflow:hidden;position:relative;width:100%}.section-default--testimonials .background{bottom:0;position:absolute;width:1440px;z-index:-1}.section-default--testimonials .bodytext{text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
